import { Input, Directive } from '@angular/core';

/**
 * Abstract class for represent component that support Ghost mode
 */
// https://angular.io/guide/migration-undecorated-classes
@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class GhostComponent {
    private _ghostMode: boolean;

    public get ghostMode(): boolean {
        return this._ghostMode;
    }

    // Input `ghostMode` for all component that extends the class
    // View will manage by herself the ghostMode boolean and not use the Input
    // Component will use parent ghost value for know if there in ghost mode or not
    // If ghostMode is set to true then the generateGhost function is call
    @Input() public set ghostMode(ghostMode: boolean) {
        this._ghostMode = ghostMode;

        if (this._ghostMode) {
            this.generateGhost();
        }
    }

    // Use for create 'ghost object', mostly object with undefined property for pass structural directive
    // View will use this for generate a skeleton
    // Component will commonly not use this because the view parent will pass the ghost object (via @Input)
    abstract generateGhost(): void;
}
